import axios from "axios";
import { has, isNil, merge, replace, startsWith } from "lodash-es";
import { authState } from "$lib/stores/AuthState.svelte";

const baseURL = replace(import.meta.env.VITE_CS_ASSET_BASE_URL, "[ORIGIN]", location.origin);

const parseUrl = url => startsWith(url, '/') ? url.substr(1) : url;
class HttpWrapperClass {

    constructor () {
        this.client = null;
        this.init();
    }

    init() {
        if(!isNil(this.client)) return;
        this.client = axios.create({ baseURL, timeout: 3600000 });
    }

    get (url, config) { return this.fetch("get", url, null, config); }
    post (url, data, config) { return this.fetch("post", url, data, config); }
    put (url, data, config) { return this.fetch("put", url, data, config); }
    delete (url, config) { return this.fetch("delete", url, null, config); }

    getAuthHeader(cfg) {
        let config = cfg || {};

        if(!config.disableAuthStore) {
            let token = authState?.identityToken;
            if (!has(cfg, "headers.Authorization")) {
                config = merge(config, { headers: { Authorization: `Bearer ${token}` } });
            }
        }

        config = merge(config, {
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate, pre-check=0, post-check=0, max-age=0, s-maxage=0',
                'Pragma': 'no-cache',
            }
        });

        return config;
    }

    fetch(method, url, data, config) {
        this.init();//ensures proper base URL; returns if already initialized
        let apiUrl = parseUrl(url);
        let apiConfig = this.getAuthHeader(config);
        let apiPromise = null;
        switch(method) {
            case "get": apiPromise = this.client.get(apiUrl, apiConfig); break;
            case "post": apiPromise = this.client.post(apiUrl, data, apiConfig); break;
            case "put": apiPromise = this.client.put(apiUrl, data, apiConfig); break;
            case "delete": apiPromise = this.client.delete(apiUrl, apiConfig); break;
        }
        return new Promise((resolve, reject) => {
            apiPromise
                .then(response => {
                    resolve(response.data);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }
}

export const HttpService = new HttpWrapperClass();
